var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"links",attrs:{"column":"","align-center":""}},[_c('v-layout',{staticClass:"content",attrs:{"row":""}},[_c('v-btn',{attrs:{"flat":"","dark":"","router-link":"","to":{name: 'PatientsPage'}}},[_vm._v(_vm._s(_vm.$t('label.patients')))]),_vm._v(" "),_c('v-spacer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e7b64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headers/DesktopHeaderLinks.vue
// module id = 386
// module chunks = 171